<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

import {getToken} from "@/js/utils/CookieUtil";
import {href} from "@/js/api/ApiConf";

export default {
  name: 'App',
  mounted() {
    // if(getToken()){
    //   window.location.href = href
    // }
  }
}
</script>

<style>
*{
  margin: 0;
  padding: 0;
}
</style>
